import { Component, OnInit, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService, readImpersonatorLogin } from '@lib/auth';
import { IUser, UserService } from '@lib/user';
import { StorageKey, StorageService, View } from '@lib/core';
import { EnvService } from '@lib/env';
import { EprocFeature } from '@lib/feature-toggle';
import { InternalEventDispatcher } from '@lib/util';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'smart-dropdown-user',
    templateUrl: './dropdown-user.component.html',
    styleUrls: ['./dropdown-user.component.scss'],
    standalone: false,
})
export class DropdownUserComponent implements OnInit {
    private readonly authService = inject(AuthService);
    private readonly userService = inject(UserService);
    private readonly storage = inject(StorageService);
    private readonly httpClient = inject(HttpClient);
    private readonly envService = inject(EnvService);

    protected readonly EprocFeature = EprocFeature;

    public view: View;
    public user: IUser;
    public isDebug = false;
    public readonly impersonatorLogin = signal<string | null>(null);

    public get userLabel(): string {
        return this.user ? `${this.user.firstName.substring(0, 1)}${this.user.surName.substring(0, 1)}`.trim() : 'U';
    }

    public logout(): void {
        this.authService.logout();
    }

    public async ngOnInit(): Promise<void> {
        this.user = await this.userService.getMyself();
        this.view = await this.userService.getViewFromUserType();
        const isDebug = await this.storage.getItem(StorageKey.EPROC_DEBUG);
        this.isDebug = isDebug && isDebug === 'true';
        this.impersonatorLogin.set(readImpersonatorLogin(await this.storage.getItem<string>(StorageKey.ACCESS_TOKEN)));
    }

    public toggleDebug(): void {
        this.isDebug = !this.isDebug;
        this.storage.setItem(StorageKey.EPROC_DEBUG, this.isDebug.toString());
        InternalEventDispatcher.DEBUG_CHANGE(this.isDebug);
    }

    public async navigateToLegacyFrontend(): Promise<void> {
        const uri = this.envService.getBase('legacy-frontend', 'redirect-url');
        const response = await firstValueFrom(
            this.httpClient.get<{ redirectUrl: string }>(uri.toString()),
        );
        window.location.href = response.redirectUrl;
    }
}
